import React from 'react';
import { Container, Col, Row, } from 'react-bootstrap';
import TAC from "../TandC";
import PP from "../PrivacyPolicy/PrivacyPolicy";
import FAQ from "../FAQ";
import './footer.css';
import BigLogo from '../assets/logo long.svg';
import Insta from '../assets/instagram.svg';
import Twitter from '../assets/twitter.svg';

export default function Footer() {

    const year = new Date().getFullYear();

    return (
        <Container fluid className="px-0 pt-5">
            <Container className="bts-footer-wrapper">
                <Row>
                    <Col xs={12} md={4}>
                         <img src={BigLogo} alt="Logo"/>
                    </Col>
                    <Col xs={12} md={5}>
                        <h5 className="lightBlue pt-0 reduce addPadding">Our Office</h5>
                        <div className="lightText">
                            <div>Garden Avenue, Enugu</div>
                        </div>
                        <h5 className="lightBlue reduce pt-3 removePadding">Contact</h5>
                        <div className="lightText">
                            +234 816 289 8892
                        </div>
                        <div className="lightText">
                            <a href="mailto:info@bitmasta.io" className="mail">info@bitmasta.io</a>
                        </div>
                    </Col>
                    <Col xs={12} md={3}>
                        <div className="pppttt">
                            <div className="pb-3">
                                <div>
                                    <h5 className="lightBlue reduce">Socials</h5>                                    
                                </div>
                                <a href="https://twitter.com/bit_masta" target="blank">
                                    <img src={Twitter} alt="" className="sos-icons"/>
                                </a>
                                <a href="https://instagram.com/bit_masta" target="blank">
                                    <img src={Insta} alt="" className="sos-icons ml-4"/>
                                </a>
                            </div>
                            <div className="pt-2">
                                <FAQ />
                            </div>
                            <div className="pt-1">
                                <TAC />
                            </div>
                            <div className="pt-1">
                                <PP />
                            </div>
                        </div>
                        <div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Container className="text-center pt-5 pb-4">
                    <span className="mail">Copyright Bitmasta Inc.</span> {" "} <br className="break" />                
                    <span className="mail">All Rights Reserved {year}</span>       
            </Container>
        </Container>
    )
}
